import AuthService from "Lib/API/Auth";
import MemberService from "Lib/API/Member";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import { setLocalizationMoment } from "./helper/dateFormat";
import EventsCalendar from "./pages/EventsCalendar";

const EventsCalenderLink = () => {
  const [events, setEvents] = useState([]);

  const generateToken = async () => {
    const subDomain = window.location.hostname.split(".")[0];
    const hostName = subDomain === "localhost" ? (process.env.REACT_APP_LOCAL_ORGKEY || "stagerms") : subDomain;
    try {
      const res = await AuthService.generateToken(hostName);
      if (!res.hasPayment) {
        window.location.replace(res?.shul_website);
        return;
      }
      localStorage.setItem("externalToken", res?.token);
      localStorage.setItem("orgId", res?._id);
      localStorage.setItem("shul_website", res?.shul_website);
      localStorage.setItem("orgHasPayment", res?.hasPayment);

      localStorage.setItem("logoImg", res?.logoImg);
      localStorage.setItem("orgName", res?.orgName);
      localStorage.setItem("country", JSON.stringify(res?.country || {}));

      setLocalizationMoment(res?.country?.local || "en");

      document.title = `${res?.orgName}`;

      const eventsRes = await MemberService.getEventsList(res?.token, res?._id);
      const calendarEntries = (eventsRes?.payload?.data || []).flatMap((event) => {
        if (event?.multiEventsDates?.length > 0) {
          return event.multiEventsDates.map((dateEntry) => {
            const utcDate = new Date(dateEntry.eventDate);
            const calDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000);
            const durationMs = (dateEntry?.eventDuration?.value || event?.eventDuration?.value || 60) * 60 * 1000;
            return {
              ...event,
              start: calDate,
              end: new Date(calDate.getTime() + durationMs),
              _utcDate: utcDate,
              title: event?.eventName,
              id: `${event?._id}_${dateEntry.eventDate}`,
              allDay: false,
            };
          });
        }
        const utcDate = event?.date ? new Date(event.date) : new Date();
        const calDate = new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60 * 1000);
        const durationMs = (event?.eventDuration?.value || 60) * 60 * 1000;
        return [{
          ...event,
          start: calDate,
          end: new Date(calDate.getTime() + durationMs),
          _utcDate: utcDate,
          title: event?.eventName,
          id: event?._id,
          allDay: false,
        }];
      });
      setEvents(calendarEntries.sort((a, b) => a.start - b.start || a.title?.localeCompare(b.title)));
    } catch (error) {
      toastr.error("Error", error?.data?.message);
    }
  };
  useEffect(() => {
    generateToken();
  }, []);

  return <EventsCalendar events={events} showList={false} />;
};

export default EventsCalenderLink;
